import { render } from "./CustomersListPage.vue?vue&type=template&id=56624adc&ts=true"
import script from "./CustomersListPage.vue?vue&type=script&lang=ts"
export * from "./CustomersListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__